"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Constants_1 = __importDefault(require("../shared/Constants"));
var __1 = require("..");
var Feature = /** @class */ (function () {
    /**
     * Construct a feature instance.
     * @param {Geometry} geom The geometry in the feature. It is required.
     * @param {Map<string, any>} properties The properties of this feature. Default is empty map.
     * @param id The id of this feature. Default id is the same as geometry's id.
     */
    function Feature(geom, properties, id) {
        var _this = this;
        this.id = 0;
        if (geom instanceof __1.Geometry) {
            this.geometry = geom;
        }
        else {
            this.geometry = __1.GeometryFactory.create(geom);
        }
        if (id !== undefined) {
            this.id = id;
        }
        else {
            this.id = this.geometry.id;
        }
        this.properties = new Map();
        if (properties !== undefined) {
            if (properties instanceof Map) {
                properties.forEach(function (v, k, m) {
                    _this.properties.set(k, v);
                });
            }
            else {
                Object.keys(properties).forEach(function (k) {
                    _this.properties.set(k, properties[k]);
                });
            }
        }
    }
    Object.defineProperty(Feature.prototype, "type", {
        get: function () {
            return Constants_1.default.TYPE_FEATURE;
        },
        enumerable: true,
        configurable: true
    });
    Feature.prototype.toJSON = function () {
        var properties = {};
        this.properties.forEach(function (v, k, m) {
            properties[k] = v;
        });
        return {
            id: this.id,
            type: this.type,
            geometry: this.geometry.toJSON(),
            properties: properties
        };
    };
    Feature.prototype.envelope = function () {
        return this.geometry.envelope();
    };
    Feature.prototype.clone = function (fields) {
        var _this = this;
        var geomClone = this.geometry.clone();
        if (fields === undefined || fields === 'all') {
            return new Feature(geomClone, this.properties, this.id);
        }
        else if (fields === 'none') {
            return new Feature(geomClone, {}, this.id);
        }
        else {
            var props_1 = new Map();
            fields.filter(function (f) { return _this.properties.has(f); }).forEach(function (f) { return props_1.set(f, _this.properties.get(f)); });
            return new Feature(geomClone, props_1, this.id);
        }
    };
    Feature.create = function (param) {
        if ('geometry' in param && param.geometry instanceof __1.Geometry) {
            var feature = param;
            return new Feature(feature.geometry, feature.properties, feature.id);
        }
        else {
            var json = param;
            if (json.type !== Constants_1.default.TYPE_FEATURE) {
                throw new Error('Not a feature json.');
            }
            if (json.geometry === undefined) {
                throw new Error('Invalid feature json.');
            }
            var geom = __1.GeometryFactory.create(json.geometry);
            return new Feature(geom, json.properties, json.id);
        }
    };
    Feature.parseJSON = function (json) {
        if (json.type !== Constants_1.default.TYPE_FEATURE) {
            throw new Error('Not a feature json.');
        }
        if (json.geometry === undefined) {
            throw new Error('Invalid feature json.');
        }
        var geom = __1.GeometryFactory.create(json.geometry);
        return new Feature(geom, json.properties, json.id);
    };
    return Feature;
}());
exports.default = Feature;
